// Graupner Butler – „An Claude senden“ (BUT-0002, 15.10.2026).
// Übergibt den Fehlerbericht (derselbe Text wie „Bericht für Spock kopieren“) an das Teilen-Menü des Geräts
// (navigator.share). Am Handy wählt Ralph dort mit einem Tipp die Claude-App. Es wird nichts selbst versendet.
// Wichtig: Handy-Browser (vor allem Safari) erlauben navigator.share nur direkt nach dem Tipp. Deshalb wird der
// Text vorher geladen (berichtVorabLaden, ohne Verlaufseintrag) und beim Tipp sofort geteilt.
import { api } from "@/lib/api";

export const teilenMoeglich = () => {
  try { return typeof navigator !== "undefined" && typeof navigator.share === "function"; } catch { return false; }
};

export const berichtVorabLaden = async (aktenzeichen) =>
  (await api.post(`/butler/fehler/${aktenzeichen}/bericht`, null, { params: { vermerken: false } })).data.text;

// Ergebnis: "geteilt" | "abgebrochen" (Teilen-Menü geschlossen – kein Fehler) | wirft bei echtem Fehler
export async function anClaudeSenden(aktenzeichen, text) {
  try {
    await navigator.share({ title: `Fehlerbericht ${aktenzeichen}`, text });
  } catch (e) {
    if (e && e.name === "AbortError") return "abgebrochen";
    throw e;
  }
  // Vermerk im Verlauf wie beim Kopieren; scheitert er, hat das Teilen trotzdem geklappt
  try { await api.post(`/butler/fehler/${aktenzeichen}/bericht-geteilt`); } catch { /* egal */ }
  return "geteilt";
}

// Kopieren wie bisher (mit Verlaufseintrag „zum Kopieren erstellt“)
export async function berichtKopieren(aktenzeichen) {
  const text = (await api.post(`/butler/fehler/${aktenzeichen}/bericht`)).data.text;
  try { await navigator.clipboard.writeText(text); return { text, kopiert: true }; } catch { return { text, kopiert: false }; }
}
